import { createFileRoute, Outlet } from '@tanstack/react-router';

import { backendApiParkAndRideFacilitiesFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/stationless/$parkAndRideFacilityId')({
  component: Outlet,
  beforeLoad: async ({ params: { parkAndRideFacilityId }, context: { queryClient } }) => {
    const facility = await queryClient.ensureQueryData(
      backendApiParkAndRideFacilitiesFindOneOptions({
        path: { parkAndRideFacilityId },
      }),
    );

    return {
      breadcrumb: facility?.name,
    };
  },
});
